<template>
  <div class="container">
    <table class="w-75 mx-auto">
      <thead>
        <tr class="row header py-2">
          <th class="col-3 text-start">
            <h5>Name</h5>
          </th>
          <th class="col-3 d-flex justify-content-center text-nowrap">
            <h5>Account Created</h5>
          </th>
          <th class="col-3 d-flex justify-content-center">
            <h5>Joined</h5>
          </th>
          <th class="col-3 d-flex align-items-center justify-content-center text-nowrap">
            <h5>Credit Applied</h5>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="referral in referrals"
          :key="referral.refereeEmail"
          class="row py-4">
          <td class="col-3">
            <h6
              :class="{ 'text-break': isTabletOrSmaller }">
              {{ referral.refereeName ? referral.refereeName : referral.refereeEmail }}
            </h6>
            <p class="small-text">
              {{ formatReferralSource(referral.source) }}
            </p>
          </td>
          <td class="col-3">
            <div class="d-flex justify-content-center">
              <referral-progress-check
                :complete="referral.accountCreated"/>
            </div>
          </td>
          <td class="col-3">
            <div class="d-flex justify-content-center">
              <referral-progress-check
                :complete="referral.joined"/>
            </div>
          </td>
          <td class="col-3">
            <div
              class="d-flex"
              :class="{'conversion-awarded': referral.conversionAwarded, 'justify-content-center': !referral.conversionAwarded}">
              <referral-progress-check
                :complete="referral.conversionAwarded">
                <template #detail>
                  <p
                    v-if="referral.conversionAwarded"
                    class="ms-xs text-pewter text-nowrap">
                    {{ formatDate(referral.conversionAwardedAt ? referral.conversionAwardedAt : referral.modified) }}
                  </p>
                </template>
              </referral-progress-check>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import ReferralProgressCheck from './ReferralProgressCheck'
import ReferralsMixin from '../global/mixins/ReferralsMixin'
import useScreenSize from '@shared/composables/screenSize.js'

export default {
  name: 'ReferralHistory',
  components: {
    ReferralProgressCheck
  },
  mixins: [ReferralsMixin],
  props: {
    referrals: {
      type: Array,
      default: () => []
    }
  },
  setup() {
    const { isTabletOrSmaller } = useScreenSize()
    return { isTabletOrSmaller }
  }
}
</script>

<style lang="scss" scoped>
  th {
    font-family: $body-font-family;
    font-size: $h4-font-size;
    font-weight: $font-weight-normal;
  }

  tr {
    border-bottom: 1px solid $ash;
  }
  .conversion-awarded {
    margin-left: calc(50% - 20px); // Center the checkmark, account for half the width of the check icon and padding
  }
</style>
